import { useEffect, useState } from "react";
import { Instance, Instances, useGLTF } from "@react-three/drei";
import useThreeJsLoader from "../../../zustand/stores/useThreeJsLoader";
import { dispose } from "@react-three/fiber";

const CaseGenerator = ({ modelSize }) => {
  const position = useThreeJsLoader((state) => state.customPosition.position);
  const scale = useThreeJsLoader((state) => state.scale);

  const { scene, nodes, materials } = useGLTF("/caseWithBorder.glb");

  const [planePositionArray, setPlanePositionArray] = useState();

  const createPositions = (modelSizeX, modelSizeZ) => {
    let minX = -Math.trunc(modelSizeX / 2);
    let minZ = -Math.trunc(modelSizeZ / 2);
    let maxX = Math.trunc(modelSizeX / 2);
    let maxZ = Math.trunc(modelSizeZ / 2);

    if (position[0] < 0) {
      minX += Math.round(position[0]);
    } else if (position[0] > 0) {
      maxX += Math.round(position[0]);
    }

    if (position[2] < 0) {
      minZ += Math.round(position[2]);
    } else if (position[2] > 0) {
      maxZ += Math.round(position[2]);
    }

    let tmp = [];
    let i, j;
    for (i = minX; i <= maxX; i++) {
      for (j = minZ; j <= maxZ; j++) {
        tmp.push([i, 0, j]);
      }
    }
    setPlanePositionArray(tmp);
  };

  useEffect(() => {
    // A surveiller
    return () => {
      dispose(scene);
      useGLTF.clear("/caseWithBorder.glb");
    };
  }, []);

  useEffect(() => {
    if (modelSize) {
      createPositions(modelSize.x || 0, modelSize.z || 0);
    }
  }, [position, modelSize, scale]);

  return (
    <Instances
      range={1000}
      material={materials.caseMaterial}
      geometry={nodes.case.geometry}
    >
      {planePositionArray?.map((casePositions, index) => {
        return (
          <group key={`plane-${index}`} position={casePositions} dispose={null}>
            <Instance receiveShadow />
          </group>
        );
      })}
    </Instances>
  );
};

export default CaseGenerator;
